import React from 'react';

import 'bootstrap/dist/css/bootstrap.css';
import './pricingoptions.styl'

import PricingOption from './pricingoption/PricingOption';

class PricingOptions extends React.Component {
  render(){
    return (
      <div>
        <div className="pricing-options">
          <PricingOption option={this.props.options._1} />
          <PricingOption option={this.props.options._2} />
          <PricingOption option={this.props.options._3} />
        </div>
        {/* 
        <div className="pricing-options-footnotes subcategory">
          <p className="subcategory-text" dangerouslySetInnerHTML={{ __html: this.props.options.footnotes.text_1 }}></p>
        </div>
         */}
      </div>
    );
  }
}

export default PricingOptions;



// WEBPACK FOOTER //
// ./src/components/pricingoptions/PricingOptions.js